module.exports = __webpack_public_path__ + "media/img/dowod_rejestracyjny-e16f0549.png";